import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useAdminUserSession } from '../../../../../models/hooks/adminStateHooks';
import { useUserSession } from '../../../../../models/hooks/appStateHooks';
import { AdminPermission } from '../../../../../viewmodels/AdminViewModels';
import filevineLogoSm from '../../../../assets/logo_filevine_sm.svg';
import { white } from '../../../../styles/colors';
import { baseStyleSheet } from '../../../../styles/styles';
import { isDeveloperOnlyIntegration } from '../../../integrations/ExternalIntegrations/availableProviders';
import { GenericIntegrationGraphic } from '../../../svgs/graphics/GenericIntegrationGraphic';
import { IntegrationCard, useIntegrationCard } from '../IntegrationCard';
import { filevineColor, styleSheet } from './styles';

export const DashboardFilevineIntegrationCard = () => {
	const userSession = useUserSession();
	const adminUserSession = useAdminUserSession();
	const { getLogoImgProps, getCloseButtonProps, getCtaButtonProps, getIntegrationTitleProps, showCard } =
		useIntegrationCard({
			closeIntegrationEventName: 'FilevineIntegrationClosed',
			enableUrlPath: `/integrations/${Api.IntegrationProvider.Filevine}`,
			integrationEnableEventName: 'FilevineIntegrationEnableClick',
			pendingAction: Api.PendingActions.ConnectFilevine,
		});

	// Matches the integrations list: customers see it once enabled, Levitate admins only with OnlyForDevelopers.
	// hasPermission doesn't exist outside an admin session.
	const isHiddenFromLevitateAdmin =
		!!userSession.impersonationContext?.account?.id &&
		isDeveloperOnlyIntegration(Api.IntegrationProvider.Filevine) &&
		!adminUserSession?.hasPermission?.(AdminPermission.OnlyForDevelopers);

	if (!showCard || !userSession.isAdmin || isHiddenFromLevitateAdmin) {
		return null;
	}

	return (
		<IntegrationCard
			closeButtonProps={getCloseButtonProps()}
			IntegrationGraphic={<GenericIntegrationGraphic color={filevineColor} />}
			headerLabel='Filevine Integration'
			logoBgColor={white}
			logoImgProps={getLogoImgProps({
				alt: 'Filevine Logo',
				className: css(styleSheet.logo),
				src: filevineLogoSm,
			})}
			ctaButtonProps={getCtaButtonProps({
				children: 'Connect with Filevine',
				styleDeclaration: [baseStyleSheet.ctaButtonReverse, styleSheet.ctaButton],
			})}
			integrationTitleProps={getIntegrationTitleProps({
				styleDeclaration: styleSheet.integrationTitle,
			})}
		>
			<p>
				We are excited to announce that you can integrate your Filevine account with Levitate. With this integration, we
				will have the ability to pull client information, including names, email, phone number, birthdays, and more
				&mdash; making staying in touch even easier.
			</p>
		</IntegrationCard>
	);
};
